






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class DatePicker extends Vue {
	@Prop({ default: null, required: false }) private model;
	@Prop({ default: null, required: false }) private errors;
	@Prop({ default: null, required: false }) private valid;
	@Prop({ default: '', required: false }) private minDate;
	@Prop({ default: '', required: false }) private maxDate;
	@Prop({ default: false, required: false }) private disabled;

	private date: any;
	private locale: any;
	private weekday: any;
	private min: any;
	private max: any;
	private modelDisabled: any;
	private labels: any;

	@Watch('model')
	modelChange(value) {
		this.date = value;
	}

	@Watch('minDate')
	minDateChange(value) {
		this.min = value;
	}

	@Watch('maxDate')
	maxDateChange(value) {
		this.max = value;
	}

	@Watch('disabled')
	disabledChange(value) {
		this.modelDisabled = value;
	}

	constructor() {
		super();
		this.date = '';
		this.locale = 'es-ES';
		this.weekday = '1';
		this.min = '';
		this.max = '';
		this.modelDisabled = false;
		this.labels = {
			'es-ES': {
					labelPrevDecade: 'Década anterior',
					labelPrevYear: 'Año anterior',
					labelPrevMonth: 'Mes anterior',
					labelCurrentMonth: 'Mes actual',
					labelNextMonth: 'Próximo mes',
					labelNextYear: 'Próximo año',
					labelNextDecade: 'Próxima década',
					labelToday: 'Hoy',
					labelSelected: 'Fecha seleccionada',
					labelNoDateSelected: 'No hay fecha seleccionada',
					labelCalendar: 'Calendario',
					labelNav: 'Navegación de calendario',
					labelHelp: 'Utilice las teclas de flecha para navegar por el calendario',
				},
		}
	}

	mounted() {
		// this.locale = this.$i18n.locale;
		if (this.model) {
			this.date = this.model;
		}
		if (this.minDate) {
			this.min = this.minDate;
		}
		if (this.minDate) {
			this.max = this.maxDate;
		}
		if (this.disabled) {
			this.modelDisabled = this.disabled;
		}
	}
}
